import { getNotificationList, readNotification, readAllNotification, getUnreadNotificationCount } from "@/apis"
import { makeAutoObservable, runInAction } from "mobx"
import { NotificationType, NotificationStatus } from "@shared/constants/notification"

export type NotificationEntity = {
  id: string
  userId: string
  type: NotificationType
  title: string
  content: string
  createdAt: Date
  updatedAt: Date
  status: NotificationStatus,
  linkUrl?: string
}

export class NotificationStore {

  notificationList: NotificationEntity[] = []
  unreadCount = 0
  loading = false

  rootStore

  constructor(rootStore) {
    makeAutoObservable(this, {
      rootStore: false
    })
    this.rootStore = rootStore
  }

  // 分页相关参数
  pageSize = 10
  currentPage = 1
  total = 0

  async getNotificationList(pageNum = 1, pageSize = 10) {
    this.currentPage = pageNum
    this.pageSize = pageSize
    this.loading = true
    const res = await getNotificationList({
      pageNum,
      pageSize
    })
    this.loading = false
    if (res.code === 0) {
      runInAction(() => {
        this.notificationList = [...this.notificationList, ...res.data.list]
        this.total = res.data.total
      })
    }
  }

  async loadMore() {
    if (this.total > this.notificationList.length) {
      await this.getNotificationList(this.currentPage + 1)
    }
    return this.total > this.notificationList.length
  }

  get hasMore() {
    return this.total > this.notificationList.length
  }

  async readNotification(id: string) {
    const res = await readNotification(id)
    if (res.code === 0) {
      runInAction(() => {
        this.notificationList = this.notificationList.map(item => {
          if (item.id === id) {
            return {
              ...item,
              status: NotificationStatus.READ
            }
          }
          return item
        })
        if (this.unreadCount > 0) {
          this.unreadCount--
        }
      })
    }
  }
  async readAllNotification() {
    const res = await readAllNotification()
    if (res.code === 0) {
      runInAction(() => {
        this.notificationList = this.notificationList.map(item => {
          return {
            ...item,
            status: NotificationStatus.READ
          }
        })
        this.unreadCount = 0
      })
    }
  }

  async getUnreadCount() {
    const res = await getUnreadNotificationCount()
    if (res.code === 0) {
      runInAction(() => {
        this.unreadCount = res.data
      })
    }
  }

  async init() {
    this.notificationList = []
    await this.getNotificationList()
    await this.getUnreadCount()
  }
}